import React from 'react';

export class SpecialSession extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleDragStart = this.handleDragStart.bind(this);
    }

    handleDragStart(event) {
        const data = {source: 'specialSession', session: this.props.session};
        event.dataTransfer.setData("text/plain", JSON.stringify(data));
    }

    render() {
        const {session} = this.props;
        return (
            <div className="panel panelspecialsession dragthis"
                 draggable="true"
                 style={{display: "block"}}
                 onDragStart={this.handleDragStart}>
                <div className="specialsession" id={session.id}>
                    <div className="panel-body">
                    <span className="pull-right" title="Delete special session">
                        <span className="glyphicon glyphicon-trash yesnomodal pointer"
                              aria-hidden="true"
                              onClick={this.props.handleRemoveClick}>
                        </span>
                    </span>
                        <span className="pull-right" title="Edit special session">
                        <span className="pull-right glyphicon glyphicon-edit openmodal-specialsession pointer"
                              aria-hidden="true"
                              onClick={this.props.showModal}>
                        </span>
                    </span>
                        <div className="specialsessiontype">{session.type}</div>
                        <div className="specialsessionchair">{session.data.chair}</div>
                        <div className="specialsessiontitle">{session.data.name}</div>
                        <div className="specialsessionauthor">{session.data.author}</div>
                        <div className="specialsessionabstract"></div>
                    </div>
                </div>
            </div>
        )
    }
}

